var map = {
	"./black/guanbihuiyi2.png": "doQd",
	"./blue/guanbihuiyi2.png": "xDJ3",
	"./white/guanbihuiyi2.png": "YL/R"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ygHq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/guanbihuiyi2\.png$
// module id = ygHq
// module chunks = 24